import script from "./dol-form-item.vue?vue&type=script&lang=js"
export * from "./dol-form-item.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__